// Scroll-lock reference count. Several Modals can be open simultaneously (a
// base modal marked `hidden` sitting behind a nested search modal). Each visible
// modal increments the count on mount and decrements on unmount; the lock is
// only released once the last one lets go. Without this, one modal's cleanup
// would clear the lock another modal still relies on.
let bodyScrollLockCount = 0
// Previous inline `overflow` on <html>, restored on the last unlock.
let prevHtmlOverflow = ''

// Lock scroll by freezing the actual scrolling element (<html>) with
// `overflow: hidden`. Unlike `position: fixed` on <body> (which collapses the
// document scroll offset to 0 and then reflows back on close — a visible
// jump-to-top-then-restore), `overflow: hidden` on <html> freezes the page IN
// PLACE: the scroll offset is preserved, nothing to save/restore, no flicker,
// and no reflow scroll on close. (GEN-4807 in-progress editing scroll fix.)
//
// Shared so other full-screen overlays (e.g. the OrderSideNav mobile drawer)
// can use the SAME ref-counted lock — a modal opened over the drawer, or the
// drawer over a modal, won't have one's teardown wipe a lock the other needs.
export function lockBodyScroll() {
  if (bodyScrollLockCount === 0) {
    prevHtmlOverflow = document.documentElement.style.overflow
    document.documentElement.style.overflow = 'hidden'
  }
  bodyScrollLockCount += 1
}

export function unlockBodyScroll() {
  bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1)
  if (bodyScrollLockCount === 0) {
    document.documentElement.style.overflow = prevHtmlOverflow
  }
}
